import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useHttpClient, type SuccessResponse } from "./httpClient";
import { storeToRefs } from "pinia";
import type { Translations } from "shared/translations/domain/translations";

export interface ListEntityApiOptions<T extends SuccessResponse> {
  url: string;
  translate: (translations: Translations) => ListEntityApiTranslations;
  processOk: (response: Response) => Promise<T>;
  excludeSite?: boolean;
}

export interface ListEntityApiTranslations {
  title: string;
  error: string;
}

export function useListEntityApi<T extends SuccessResponse>(options: ListEntityApiOptions<T>) {
    const httpClient = useHttpClient();
    const languageStore = useLanguageStore();
    const { translations } = storeToRefs(languageStore);

    return {
      execute
    };

    async function execute() {
      const headers = httpClient.defaultHeaders();

      const url = options.excludeSite ? `api/${options.url}` : httpClient.siteUrl(options.url);

      const request = new Request(url, {
        method: 'GET',
        headers,
      });

      const text = options.translate(translations.value);

      const response = await httpClient.action<T>(request, {
        title: text.title,
        errorTitle: text.error,
        processOk: options.processOk
      });

      return response;
    }
}
